import { QueryClient } from '@tanstack/preact-query';
import { ApiError, ArcticApiClient } from '../arcticapi';

export interface WidgetRuntimeOptions {
  tenant: string;
  baseUrl?: string;
}

export function createWidgetApiClient({
  tenant,
  baseUrl,
}: WidgetRuntimeOptions): ArcticApiClient {
  return new ArcticApiClient({ tenant, baseUrl });
}

export function createWidgetQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (
            error instanceof ApiError &&
            error.status >= 400 &&
            error.status < 500
          ) {
            return false;
          }

          return failureCount < 3;
        },
      },
    },
  });
}
